import React from 'react';
import PropTypes from 'prop-types';
import assets from "../../util/assets";
import ProgressiveImage from "react-progressive-image";
import "./index.css";

ProfilePic.propTypes = {
    profile_pic: PropTypes.string.isRequired,
    user_type: PropTypes.string.isRequired,
    is_verified: PropTypes.number,
};

ProfilePic.defaultProps = {
    onClick: () => {

    }
}

const getBroadcasterVerifiedImage = (props) => {
    if (props.user_type === "broadcaster") {
        return (
            <img
                src={props.is_verified === 1 ? assets.clipstore.home.broadcaster_verified : assets.clipstore.home.broadcaster_unverified}
                alt="verified broadcaster"/>
        )
    } else {
        return (<span/>)
    }
}

function ProfilePic(props) {
    return (
        <ProgressiveImage
            delay={1000}
            src={props.profile_pic}
            placeholder="placeholder"
        >
            {(src, loading) => {
                return loading ? (
                        <img alt="broadcaster profile picture"
                             className="broadcaster-profile-pic-container"
                             src={assets.user_placeholder}/>
                    ) :
                    (
                        <div className="broadcaster-profile-pic-container"
                             onClick={props.onClick}
                             style={{backgroundImage: "url('" + props.profile_pic + "')"}}>

                            {getBroadcasterVerifiedImage(props)}

                        </div>
                    )

            }}
        </ProgressiveImage>
    );
}

export default ProfilePic;